import { supabase, sessionUser } from "./supabase";
export async function loadAccount() {
  const user = await sessionUser();
  if (!user) throw new Error("Sign in to continue");
  const [application, profile, roles, season, teams] = await Promise.all([
    supabase.rpc("get_my_season_application"),
    supabase
      .from("profiles")
      .select("id,display_name,avatar_url,notification_preferences")
      .eq("id", user.id)
      .single(),
    supabase.from("app_roles").select("role").eq("user_id", user.id),
    supabase.rpc("current_season_context_v2"),
    supabase.rpc("get_my_season_teams"),
  ]);
  for (const result of [application, profile, roles, season, teams])
    if (result.error) throw result.error;
  return {
    user,
    application: application.data,
    profile: profile.data,
    admin:
      roles.data?.some((r) => r.role === "admin" || r.role === "super_admin") ??
      false,
    season: season.data,
    teams: teams.data,
  };
}
export const accountKey = ["account"];
export async function savePreferences(values: Record<string, unknown>) {
  const user = await sessionUser();
  if (!user) throw new Error("Sign in to continue");
  const { error } = await supabase
    .from("profiles")
    .update({
      notification_preferences: values,
      updated_at: new Date().toISOString(),
    })
    .eq("id", user.id);
  if (error) throw error;
}
